



































































































































import IRPTQueries from '@/store/models/IRPTQueries';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TableRowAction from '../shared/TableRowAction.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class RPTQueriesSelector extends Vue {
    searchRPTQueries: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Name', value: 'queryName' },
        { text: 'Instruction', value: 'queryInstruction' },
        { text: 'Actions', value: '' }
    ];
    editedIndex : number = -1;
    editedItem : IRPTQueries = {
        id: "",
        queryName: "",
        queryInstruction: ""
    }
    defaultItem : IRPTQueries = {
        id: "",
        queryName: "",
        queryInstruction: ""
    }
    sortBy: string = 'queryName';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    RPTQueriesList !: IRPTQueries[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedRPTQueries : IRPTQueries[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Query' : 'Edit Query'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetRPTQueries() {
        this.selectedRPTQueries = [];
    }

    editRPTQueries (item: any, dbox = true) {
        this.editedIndex = this.RPTQueriesList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveRPTQueries (listAdressType: IRPTQueries) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedRPTQueries[0]) {
                this.close();
                this.$emit('editRPTQueries', this.editedItem);
                Object.assign(this.RPTQueriesList[this.editedIndex], this.editedItem);
            } else {
                this.selectedRPTQueries[0] = this.editedItem;
                this.$emit('saveRPTQueries', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteRPTQueries (listAdressType: IRPTQueries) {
        this.$emit('deleteRPTQueries', listAdressType);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectRPTQueries(item : any) : void {
        if (!this.selectedRPTQueries.includes(item)) {
            this.selectedRPTQueries = [];
            this.selectedRPTQueries = [item];
        } else {
            this.selectedRPTQueries = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
